import { NotificationsService } from './../../notification/activenotifications/notifications.service';
import { NotificationEmailList } from './../../notification/activenotifications/qaticketnotification.model';
import { AuthenticationService } from './../../shared/authentication.service';
import { QuestionService } from './../../shared/questionService';
import { RolesForSendingFeedback, QAResponse } from '../../shared/qaTicket';
import { TicketService } from './../../shared/ticketService';
import { ConfirmdialogComponent } from './../confirmdialog/confirmdialog.component';
import { InfodialogComponent } from './../infodialog/infodialog.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SendFeedBack } from '../../shared/qaTicket';
import { LocalStorage } from '../../shared/localstorage.service';




@Component({
  selector: "app-sendfeedback",
  templateUrl: "./sendfeedback.component.html",
  styleUrls: ["./sendfeedback.component.scss"]
})

export class SendfeedbackComponent implements OnInit {

  notificationemails = new FormControl();
  notificationemailscriticallevel = new FormControl();
  emailList: NotificationEmailList[] = [];
  emilListBasedOnCriticalLevel: NotificationEmailList[] = [];
  notificationemaillist: string[] = [];
  criticallevelemaillist: string[] = [];
  excavatorFeedback: string = "";
  locationFeedback: string = "";
  mappingFeedback: string = "";
  notificationFeedback: string = "";
  remarksFeedback: string = "";
  sendFeedbackText: string = "";
  role: string = "";
  rolesForUser: RolesForSendingFeedback;
  includeTakenBy: boolean = false;
  qaresponses: QAResponse[];
  CriticalLevel: number;

  constructor(public dialogRef: MatDialogRef<SendfeedbackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public ticketService: TicketService,
    public questionService: QuestionService,
    public localStorage: LocalStorage,
    public notificationService: NotificationsService,
    public authService: AuthenticationService) { }


  ngOnInit() {
    this.notificationService.getEmailList().subscribe(res => {
      this.emailList = res;
      var takenByEmail = new NotificationEmailList();
      takenByEmail.EmailAddress = 'Include Taken By';
      takenByEmail.Name = 'Include Taken By';
      takenByEmail.QueueCategory = 'Include Taken By';
      this.emailList.push(takenByEmail);


      this.excavatorFeedback = this.data.execavatorFeedback;
      this.locationFeedback = this.data.locationFeedback;
      this.mappingFeedback = this.data.mappingFeedback;
      this.notificationFeedback = this.data.notificationFeedback;
      this.remarksFeedback = this.data.remarksFeedback;
      this.qaresponses = this.data.responses;


      this.qaresponses.forEach(response => {
        if (response.CriticalLevel === 3) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
              if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === 3) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) !== -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) !== -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
        else if (response.CriticalLevel === 2) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
            if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === 2) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) !== -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) !== -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
        else if (response.CriticalLevel === 1) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
            if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === 1) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) !== -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) !== -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
        else if (response.CriticalLevel === 0) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
            if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === 0) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) !== -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) !== -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
        else if (response.CriticalLevel === -1) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
            if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === -1) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) !== -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) === -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
        else if (response.CriticalLevel === -2) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
            if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === -2) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) === -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) !== -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
        else if (response.CriticalLevel === -3) {
          if (response.ResponseValue.toLowerCase() !== 'na') {
            if (response.ResponseValue.toLowerCase() !== response.ValidResponse.toLowerCase()) {
              this.emailList.forEach(emailelement => {
                if (emailelement.CriticalLevel === -3) {
                  if (this.emilListBasedOnCriticalLevel.findIndex(x => x.Name ===
                    emailelement.Name) === -1) {
                    this.emilListBasedOnCriticalLevel.push(emailelement);
                  }
                }
              });
              this.emilListBasedOnCriticalLevel.forEach(criticallevelemail => {
                if (this.emailList.findIndex(x => x.Name ===
                  criticallevelemail.Name) !== -1) {
                  var index = this.emailList.findIndex(x => x.Name ===
                    criticallevelemail.Name);
                  this.emailList.splice(index, 1);
                }
              });
            }
          }
        }
      });
    });
  }

  OnOkClick() {
    if (this.criticallevelemaillist.length > 0) {
      this.criticallevelemaillist.forEach(element => {
        this.notificationemaillist.push(element);
      });
    }
    if (this.notificationemaillist.length === 0) {
      let infoDialofForEmailError = this.dialog.open(InfodialogComponent, {
        width: '500px',
        data: {
          title: 'Alert',
          content: 'Please select atleast one email address to send feedback.'
        }
      });
      return;
    } if (this.sendFeedbackText === "") {
      let infoDialofForEmailError = this.dialog.open(InfodialogComponent, {
        width: '500px',
        data: {
          title: 'Alert',
          content: 'Please provide feedback.'
        }
      });
      return;
    }
    let infoDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      data: {
        title: 'Alert',
        content: 'Please make sure the feedback entered is correct. We are sending the feedback now.'
      }
    });

    infoDialog.afterClosed().subscribe(result => {
      if (result !== 'Cancel') {
        var sendFeedBackObj = new SendFeedBack();
        sendFeedBackObj.SendFeedBackText = this.sendFeedbackText;
        sendFeedBackObj.SendFeedBackTo = this.notificationemaillist;
        sendFeedBackObj.QARole = this.authService.role;
        for (let i = 0; i < sendFeedBackObj.SendFeedBackTo.length; i++) {
          if (sendFeedBackObj.SendFeedBackTo[i] === 'Include Taken By') {
            this.includeTakenBy = true;
          }
        }
        if (this.includeTakenBy) {
          this.questionService.getRolesForUserToSendFeedBack(this.localStorage.getItem("token"),
            this.ticketService.ticket.takenBy, this.localStorage.getItem('currentState')).subscribe(res => {
              this.rolesForUser = res;
              if (this.rolesForUser.role[0].name.indexOf("Portal") > -1 || this.rolesForUser.role[0].name.indexOf("Remote") > -1) {
                sendFeedBackObj.SendFeedBackTo.pop();
                sendFeedBackObj.SendFeedBackTo.push(this.ticketService.ticket.takenBy);
                this.dialogRef.close(sendFeedBackObj);
                return;
              }
              else {
                this.questionService.getEmailAddressForUserToSendFeedBack(this.localStorage.getItem("token"),
                  this.ticketService.ticket.takenBy, this.localStorage.getItem('currentState')).subscribe(res => {
                    if (res.toString() !== "" || res.toString() !== null) {
                      sendFeedBackObj.SendFeedBackTo.pop();
                      sendFeedBackObj.SendFeedBackTo.push(res.toString());
                      this.dialogRef.close(sendFeedBackObj);
                      return;
                    }
                    else {
                      sendFeedBackObj.SendFeedBackTo.pop();
                      this.dialogRef.close(sendFeedBackObj);
                      return;
                    }
                  });
              }
            });
        }
        else {
          this.dialogRef.close(sendFeedBackObj);
        }

      }
    });
  }
  OnCancelClick() {
    this.dialogRef.close('Cancel');
  }
}
